import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Hero = makeShortcode("Hero");
const Resources = makeShortcode("Resources");
const DiscoverBlock = makeShortcode("DiscoverBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Hero slots="image, heading, text" mdxType="Hero" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "41.5625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/commerce/php/static/d196a8cfb9d567947b40b894f4a86e65/5530d/home-bg.webp 320w", "/commerce/php/static/d196a8cfb9d567947b40b894f4a86e65/0c8fb/home-bg.webp 640w", "/commerce/php/static/d196a8cfb9d567947b40b894f4a86e65/94b1e/home-bg.webp 1280w", "/commerce/php/static/d196a8cfb9d567947b40b894f4a86e65/0b34d/home-bg.webp 1920w", "/commerce/php/static/d196a8cfb9d567947b40b894f4a86e65/fab06/home-bg.webp 2000w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/commerce/php/static/d196a8cfb9d567947b40b894f4a86e65/8980b/home-bg.jpg 320w", "/commerce/php/static/d196a8cfb9d567947b40b894f4a86e65/56d4e/home-bg.jpg 640w", "/commerce/php/static/d196a8cfb9d567947b40b894f4a86e65/62aaf/home-bg.jpg 1280w", "/commerce/php/static/d196a8cfb9d567947b40b894f4a86e65/aaf92/home-bg.jpg 1920w", "/commerce/php/static/d196a8cfb9d567947b40b894f4a86e65/451a4/home-bg.jpg 2000w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/commerce/php/static/d196a8cfb9d567947b40b894f4a86e65/62aaf/home-bg.jpg",
            "alt": "Commerce PHP Extensions",
            "title": "Commerce PHP Extensions",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h1 {...{
      "id": "commerce-php-extensions"
    }}>{`Commerce PHP Extensions`}</h1>
    <p>{`Learn how to create and maintain PHP extensions for Adobe Commerce and Magento Open Source.`}</p>
    <Resources slots="heading, links" mdxType="Resources" />
    <h2 {...{
      "id": "resources"
    }}>{`Resources`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/open/magento"
        }}>{`Commerce open-source projects`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://opensource.magento.com/slack"
        }}>{`Community Slack workspace`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/open/magento/statistic"
        }}>{`Contributor statistics`}</a></li>
    </ul>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`This documentation provides resources for developing PHP-based extensions for Adobe Commerce and Magento Open Source.`}</p>
    <h2 {...{
      "id": "discover"
    }}>{`Discover`}</h2>
    <p>{`Use these sections to learn about how to develop PHP extensions.`}</p>
    <DiscoverBlock slots="heading, link, text" mdxType="DiscoverBlock" />
    <h3 {...{
      "id": "sections"
    }}>{`Sections`}</h3>
    <p><a parentName="p" {...{
        "href": "architecture/"
      }}>{`Architecture`}</a></p>
    <p>{`Explore resources that describe the foundational elements of the Adobe Commerce and Magento Open Source framework.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "development/"
      }}>{`Extension Development`}</a></p>
    <p>{`Learn about extending or customizing Adobe Commerce and Magento Open Source components. Apply this knowledge to create components that introduce new functionality and distribute them to merchants.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "best-practices/"
      }}>{`Best Practices`}</a></p>
    <p>{`Use this collection of best practices curated by the community as well as the Adobe User Experience (UX), Product Management, and Engineering teams to avoid commonly reported issues in third-party Adobe Commerce and Magento Open source extensions.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "module-reference/"
      }}>{`Module Reference`}</a></p>
    <p>{`Get module names and descriptions for PHP modules specific to Magento Open Source, Adobe Commerce, and B2B for Adobe Commerce.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "coding-standards/"
      }}>{`Coding Standards`}</a></p>
    <p>{`Review Adobe Commerce and Magento Open Source coding standards for different languages, including PHP, JavaScript, LESS, and jQuery.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "tutorials/"
      }}>{`Tutorials`}</a></p>
    <p>{`Follow step-by-step tutorials to customize default Adobe Commerce and Magento Open Source features, including checkout, attributes, and the product creation form.`}</p>
    <DiscoverBlock width="100%" slots="heading, link, text" mdxType="DiscoverBlock" />
    <h2 {...{
      "id": "contributing-to-this-documentation"
    }}>{`Contributing to this documentation`}</h2>
    <p>{`We encourage you to participate in our open documentation initiative. If you have suggestions, corrections, additions, or deletions for this documentation, check out the source on `}<a parentName="p" {...{
        "href": "https://github.com/adobedocs/commerce-php"
      }}>{`GitHub`}</a>{`, and open a pull request.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      